// import React, { useEffect, useRef } from "react";
// import "./AdsSection.css";

// import ad1 from "../../../assets/images/digitallll.png";
// import ad2 from "../../../assets/images/digitallll.png";
// import ad3 from "../../../assets/images/digitallll.png";
// import ad4 from "../../../assets/images/digitallll.png";
// import ad5 from "../../../assets/images/digitallll.png";
// import ad6 from "../../../assets/images/digitallll.png";
// import ad7 from "../../../assets/images/digitallll.png";
// import ad8 from "../../../assets/images/digitallll.png";

// const adsData = [
//   { img: ad1, title: "Employee Onboarding", desc: "Digitally onboard new hires" },
//   { img: ad2, title: "Payroll Management", desc: "Salary & tax automation" },
//   { img: ad3, title: "Attendance & Leave", desc: "Shift & leave tracking" },
//   { img: ad4, title: "Performance Review", desc: "KPI & appraisals" },
//   { img: ad5, title: "Recruitment Tracker", desc: "Hiring pipeline" },
//   { img: ad6, title: "HR Compliance", desc: "Policies & records" },
//   { img: ad7, title: "Training & LMS", desc: "Employee learning" },
//   { img: ad8, title: "HR Analytics", desc: "Smart HR insights" },
// ];

// const AdsSectionVertical = () => {
//   const adsRef = useRef(null);
//   const intervalRef = useRef(null);

//   useEffect(() => {
//     startScroll();
//     return stopScroll;
//   }, []);

//   const startScroll = () => {
//     if (intervalRef.current) return;

//     intervalRef.current = setInterval(() => {
//       if (adsRef.current) {
//         adsRef.current.scrollTop += 1;
//         if (adsRef.current.scrollTop >= adsRef.current.scrollHeight / 2) {
//           adsRef.current.scrollTop = 0;
//         }
//       }
//     }, 30);
//   };

//   const stopScroll = () => {
//     clearInterval(intervalRef.current);
//     intervalRef.current = null;
//   };

//   return (
//     <aside
//       className="ads-section-vertical"
//       ref={adsRef}
//       onMouseEnter={stopScroll}
//       onMouseLeave={startScroll}
//     >
//       {[...adsData, ...adsData].map((ad, index) => (
//         <a
//           key={index}
//           href="#"
//           className="ad-card-vertical"
//           style={{ backgroundImage: `url(${ad.img})` }}
//         >
//           <div className="ad-overlay-vertical">
//             <h4>{ad.title}</h4>
//             <p>{ad.desc}</p>
//           </div>
//         </a>
//       ))}
//     </aside>
//   );
// };

// export default AdsSectionVertical;




import React, { useState, useRef } from "react";
import "./AdsSection.css";

import ad1 from "../../../assets/images/digitallll.png";
import ad2 from "../../../assets/images/digitallll.png";
import ad3 from "../../../assets/images/digitallll.png";
import ad4 from "../../../assets/images/digitallll.png";
import ad5 from "../../../assets/images/digitallll.png";
import ad6 from "../../../assets/images/digitallll.png";
import ad7 from "../../../assets/images/digitallll.png";
import ad8 from "../../../assets/images/digitallll.png";

// Sample ads with category
const adsData = [
  { img: ad1, title: "Employee Onboarding", category: "HR" },
  { img: ad2, title: "Payroll Management", category: "Finance" },
  { img: ad3, title: "Attendance & Leave", category: "HR" },
  { img: ad4, title: "Performance Review", category: "HR" },
  { img: ad5, title: "Recruitment Tracker", category: "HR" },
  { img: ad6, title: "HR Compliance", category: "Finance" },
  { img: ad7, title: "Training & LMS", category: "HR" },
  { img: ad8, title: "HR Analytics", category: "Finance" },
];

const AdsSectionFilter = () => {
  const [filter, setFilter] = useState("All");
  const sliderRef = useRef(null);

  const filteredAds =
    filter === "All"
      ? adsData
      : adsData.filter((ad) => ad.category === filter);

  // Manual scroll for mobile slider
  const handleScroll = (direction) => {
    if (sliderRef.current) {
      const width = sliderRef.current.clientWidth;
      sliderRef.current.scrollBy({
        left: direction === "next" ? width : -width,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="ads-section-wrapper">
      {/* Filter */}
      <div className="ads-filter">
        <button
          className={filter === "All" ? "active" : ""}
          onClick={() => setFilter("All")}
        >
          All
        </button>
        <button
          className={filter === "HR" ? "active" : ""}
          onClick={() => setFilter("HR")}
        >
          HR
        </button>
        <button
          className={filter === "Finance" ? "active" : ""}
          onClick={() => setFilter("Finance")}
        >
          Finance
        </button>
      </div>

      {/* Ads Container */}
      <div className="ads-section" ref={sliderRef}>
        {filteredAds.map((ad, index) => (
          <a
            key={index}
            href="#"
            className="ad-card-filter"
            style={{ backgroundImage: `url(${ad.img})` }}
          >
            <div className="ad-overlay-filter">
              <h4>{ad.title}</h4>
              <p>{ad.category}</p>
            </div>
          </a>
        ))}
      </div>

      {/* Manual scroll buttons (mobile) */}
      {/* <div className="ads-nav-buttons">
        <button onClick={() => handleScroll("prev")}>◀</button>
        <button onClick={() => handleScroll("next")}>▶</button>
      </div> */}
    </div>
  );
};

export default AdsSectionFilter;

